import { objSrc } from './home/ObjectLibrary';
import React, { useState } from 'react';
import { Pencil, X, RotateCcw, Check } from 'lucide-react';
import { useTenant } from '../contexts/TenantContext';
import { ObjectGrid, useBrandingSave } from './home/ObjectLibrary';

// Popover de choix d'objet pour une entrée de la sidebar (mode Personnaliser)
export const NavObjectPicker = ({ target, current, onClose }) => {
  const { tenant } = useTenant();
  const save = useBrandingSave();
  const [busy, setBusy] = useState(false);
  const overrides = tenant?.branding?.nav_objects || {};
  const pick = async (id) => {
    setBusy(true);
    const next = { ...overrides };
    if (id === null) delete next[target.key]; else next[target.key] = id;
    await save('nav_objects', Object.keys(next).length ? next : null, id ? 'Icône mise à jour' : 'Icône par défaut rétablie');
    setBusy(false);
  };
  return (
    <div className="da-nav-picker" data-testid="nav-object-picker">
      <div className="hh-picker-head">
        <img src={objSrc(current)} alt="" className="da-nav-picker-cur" />
        <b>{target.label}</b>
        {overrides[target.key] && <button type="button" onClick={() => pick(null)} disabled={busy} data-testid="nav-object-reset" title="Icône par défaut"><RotateCcw size={13} /> Défaut</button>}
        <button type="button" onClick={onClose} aria-label="Fermer" data-testid="nav-object-close"><X size={15} /></button>
      </div>
      <ObjectGrid value={current} disabled={busy} cols={7} onPick={pick} testPrefix="nav-object" />
    </div>
  );
};

export const NavCustomizeToggle = ({ on, onToggle }) => (
  <button type="button" onClick={onToggle} className={`da-nav-customize ${on ? 'is-on' : ''}`} data-testid="nav-customize-toggle">
    {on ? <Check size={14} /> : <Pencil size={14} />} {on ? 'Terminer' : 'Personnaliser le menu'}
  </button>
);
